import '@styles/CheckBox/style.css'
import React from 'react'
import Typography from '../Typography'

export interface ICheckBoxProps {
  label?: string
  name: string
  id: string
  checked?: boolean
  checkBoxClick?: (ev: any) => void
  variant?: any
  classes?: any
  disabled?: boolean
  className?: string
}

const CheckBox: React.FC<ICheckBoxProps> = ({
  label,
  name,
  id,
  checked,
  checkBoxClick,
  variant,
  classes,
  disabled,
  className
}) => {
  return (
    <label className='container'>
      {label && (
        <Typography
          classes={classes}
          variant={variant ?? 'list'}
          color='primary'
          disabled={disabled}
        >
          {label}
        </Typography>
      )}
      <input
        type='checkbox'
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={checkBoxClick}
        className={className}
      />
      <span className='checkmark'></span>
    </label>
  )
}

export default CheckBox
